var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('div',{staticClass:"content"},[_c('div'),_c('progress',{staticClass:"progress",attrs:{"max":"50"},domProps:{"value":_vm.progrsesValue1}})])])}
var staticRenderFns = []

export { render, staticRenderFns }